export const stopAfterAttempt = (maxAttempts = 10) => ({
  shouldStop: ({ attempt }) => attempt >= (maxAttempts || 10),
});

export const stopAfterDelay = (maxDelayMs = 10000) => ({
  shouldStop: ({ elapsed }) => elapsed >= (maxDelayMs || 10000),
});

export const waitFixed = (delayMs) => ({
  computeDelay: () => delayMs,
});

export const waitExponential = ({
  min = 500,
  max = 10000,
  multiplier = 2,
  jitter = true,
} = {}) => ({
  computeDelay: (attemptNumber) => {
    let delay = Math.min(min * Math.pow(multiplier, attemptNumber - 1), max);
    if (jitter) {
      const factor = 0.75 + Math.random() * 0.5;
      delay *= factor;
    }
    return delay;
  },
});

export const retryAlways = () => () => true;

export const retryIfExceptionType = (allowedErrors) => (error) =>
  allowedErrors.some((errType) => error instanceof errType);

export async function retry(
  fn,
  {
    stop = stopAfterAttempt(3),
    wait = waitFixed(1000),
    retry = retryAlways(),
    failedCallback = null,
  } = {}
) {
  const startTime = Date.now();
  let attempt = 0;
  let shouldRetry = true;

  let result, fnError;

  while (shouldRetry) {
    attempt++;

    try {
      result = await fn();
    } catch (error) {
      result = error;
      fnError = error;
    }

    const shouldRetryError = retry(result);

    if (shouldRetryError) {
      console.warn(`Attempt ${attempt} failed.`, result);
    }

    const elapsed = Date.now() - startTime;
    const shouldStop = stop.shouldStop({ attempt, elapsed });

    shouldRetry = !shouldStop && shouldRetryError;

    if (shouldRetry) {
      const delay = wait.computeDelay(attempt);
      console.info(`Retrying in ${Math.round(delay)} ms...`);
      await new Promise((res) => setTimeout(res, delay));
    } else if (
      (fnError || shouldRetryError) &&
      failedCallback &&
      typeof failedCallback === "function"
    ) {
      await failedCallback(result);
    }
  }

  return result;
}
